import moment from 'moment';

const isCurrentYear = year => {
  // year === undefined is a case when the overview year === all
  return [undefined, moment().year()].includes(year);
};
export default isCurrentYear;
